/* eslint-disable no-underscore-dangle */
import { Item, Service, Subscription } from '@front/common/types'
import {
  deleteItem,
  deleteService,
  getFlattenItems,
  getPrivateNamespaceName,
  upsertItem,
  upsertService,
} from '@front/common/utils'

import {
  DELETE_ITEM,
  DELETE_SERVICE,
  UPSERT_ITEM,
  UPSERT_SERVICE,
} from './constants'

interface Istate {
  subscription: Subscription
}

/* eslint-disable no-param-reassign */
export default {
  namespaced: true,
  state: {
    subscription: {},
  },
  getters: {
    get: (state: Istate): Subscription => state.subscription,
  },
  mutations: {
    insert(state: Istate, payload: Subscription): void {
      state.subscription = payload
    },
    [getPrivateNamespaceName(DELETE_SERVICE)](
      argState: Istate,
      payload: Service['id'],
    ): void {
      argState.subscription.services = deleteService(
        payload,
        argState.subscription.services,
      )
    },
    [getPrivateNamespaceName(UPSERT_SERVICE)](
      argState: Istate,
      payload: Service,
    ): void {
      argState.subscription.services = upsertService(
        payload,
        argState.subscription.services,
      )
    },
    [getPrivateNamespaceName(UPSERT_ITEM)](state: Istate, payload: Item) {
      const service = state.subscription.services.find(({ id }) => {
        return id === payload?.serviceId
      })

      if (!service) {
        return
      }

      const newService = {
        ...service,
        items: upsertItem(payload, service.items),
      }

      state.subscription.services = upsertService(
        newService,
        state.subscription.services,
      )
    },
    [getPrivateNamespaceName(DELETE_ITEM)](state: Istate, payload: Item['id']) {
      const item = getFlattenItems(state.subscription.services).find(
        ({ id }) => {
          return id === payload
        },
      )
      const service = state.subscription.services.find(({ id }) => {
        return id === item?.serviceId
      })

      if (!service) {
        return
      }

      const newService = {
        ...service,
        items: deleteItem(payload, service.items),
      }

      state.subscription.services = upsertService(
        newService,
        state.subscription.services,
      )
    },
  },
}
